export default "__VITE_ASSET__f3a4f408__"